// Clés = IncidentPriorityEnum (tickets support).
const PRIO_META = {
  LOW: { cls: "low", label: "Faible" },
  MEDIUM: { cls: "normal", label: "Normale" },
  HIGH: { cls: "high", label: "Haute" },
  CRITICAL: { cls: "critical", label: "Critique" },
};

export function PrioBadge({ priorite }) {
  const m = PRIO_META[priorite] || { cls: "normal", label: priorite || "—" };
  return (
    <span className={`prio ${m.cls}`}>
      <span className="bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </span>
      {m.label}
    </span>
  );
}

export default PrioBadge;
